import classNames from 'classnames';
import Modal from 'components/modal';
import SendReplyMSG from 'components/modal/sendReplyMSG';
import {useState} from 'react';

interface MessageButtonProps {
  post_type: string;
  post: string;
  profile_type: string;
  disabled?: boolean;
}
const MessageButton = ({
  post_type,
  post,
  profile_type,
  disabled,
}: MessageButtonProps) => {
  const [isSendMSGOpen, setIsSendMSGOpen] = useState<boolean>(false);

  return (
    <>
      <button
        disabled={disabled}
        className={classNames(
          ' w-full rounded-md bg-primary text-center text-white py-4',
          {'!bg-gray-300': disabled},
        )}
        onClick={() => setIsSendMSGOpen(!isSendMSGOpen)}
      >
        <span className="icon-chat text-white mx-1"></span>
        پیام به فروشنده
      </button>
      <Modal isOpen={isSendMSGOpen} setIsOpen={setIsSendMSGOpen}>
        <SendReplyMSG
          post={post}
          setIsOpen={setIsSendMSGOpen}
          post_type={post_type}
          profile_type={profile_type}
        />
      </Modal>
    </>
  );
};

export default MessageButton;
